var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductEclipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 188,
    viewBox: "0 0 465 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_186_308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399 208C399 189.352 392.443 170.887 379.703 153.659C366.964 136.431 348.291 120.777 324.752 107.591C301.212 94.4049 273.266 83.9453 242.51 76.8091C211.754 69.6729 178.79 66 145.5 66C112.21 66 79.2458 69.6729 48.4897 76.8091C17.7337 83.9453 -10.2119 94.4049 -33.7516 107.591C-57.2912 120.777 -75.9639 136.431 -88.7035 153.659C-101.443 170.887 -108 189.352 -108 208L145.5 208H399Z",
    fill: "#FFF4D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_186_308",
    x: -173.4,
    y: 0.599998,
    width: 637.8,
    height: 272.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32.7,
    result: "effect1_foregroundBlur_186_308"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductEclipse);
export default __webpack_public_path__ + "static/media/productEclipse.520c051854a987619102edc92c4121f1.svg";
export { ForwardRef as ReactComponent };